import React from "react";
import { Button } from "./button";
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from "lucide-react";

export const Pagination = ({ page, pages, total, pageSize, onPageChange }) => {
    if (!pages || pages <= 1) return null;

    const getVisiblePages = () => {
        const visible = [];
        const start = Math.max(1, page - 2);
        const end = Math.min(pages, page + 2);
        for (let i = start; i <= end; i++) visible.push(i);
        return visible;
    };

    return (
        <div className="flex items-center justify-between pt-4" data-testid="pagination">
            <p className="text-sm text-muted-foreground">
                {total} résultat{total !== 1 ? "s" : ""} — page {page}/{pages}
            </p>
            <div className="flex items-center gap-1">
                <Button
                    variant="outline" size="icon" className="h-8 w-8"
                    disabled={page <= 1}
                    onClick={() => onPageChange(1)}
                    data-testid="pagination-first"
                >
                    <ChevronsLeft className="w-4 h-4" />
                </Button>
                <Button
                    variant="outline" size="icon" className="h-8 w-8"
                    disabled={page <= 1}
                    onClick={() => onPageChange(page - 1)}
                    data-testid="pagination-prev"
                >
                    <ChevronLeft className="w-4 h-4" />
                </Button>
                {getVisiblePages().map(p => (
                    <Button
                        key={p}
                        variant={p === page ? "default" : "outline"}
                        size="icon"
                        className="h-8 w-8 text-xs"
                        onClick={() => onPageChange(p)}
                        data-testid={`pagination-page-${p}`}
                    >
                        {p}
                    </Button>
                ))}
                <Button
                    variant="outline" size="icon" className="h-8 w-8"
                    disabled={page >= pages}
                    onClick={() => onPageChange(page + 1)}
                    data-testid="pagination-next"
                >
                    <ChevronRight className="w-4 h-4" />
                </Button>
                <Button
                    variant="outline" size="icon" className="h-8 w-8"
                    disabled={page >= pages}
                    onClick={() => onPageChange(pages)}
                    data-testid="pagination-last"
                >
                    <ChevronsRight className="w-4 h-4" />
                </Button>
            </div>
        </div>
    );
};
